import { render, staticRenderFns } from "./GanttChartV2.vue?vue&type=template&id=418384ca&scoped=true&"
import script from "./GanttChartV2.vue?vue&type=script&lang=js&"
export * from "./GanttChartV2.vue?vue&type=script&lang=js&"
import style0 from "./GanttChartV2.vue?vue&type=style&index=0&id=418384ca&lang=scss&scoped=true&"
import style1 from "./GanttChartV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418384ca",
  null
  
)

export default component.exports